import { CheckCircle2 } from "lucide-react";
import ContactButtons from "@/components/ContactButtons";
import { PARENT_BRAND } from "@/lib/brand";
import mariaPriestly from "@/assets/maria-priestly-empress-elite.jpg?format=webp&quality=72&w=900&imagetools";

const PROMISES = [
  "You'll be texting me, a real person",
  "Your quote in writing before you book",
  "A 50% deposit secures your date",
];

/**
 * The booking spot on every page (#booking): no form, just text Maria, WhatsApp or call.
 * Every "Check My Date" button on the site scrolls here.
 */
export default function TextMariaSection({
  title = "Text Me Your Date. I'll Check It Myself.",
  body = "No forms. Tell me the day, where we're picking you up and how many are coming, and I'll check availability and send your quote in writing. Texting me is the fastest way to check your date.",
}: {
  title?: string;
  body?: string;
}) {
  return (
    <section
      id="booking"
      data-track-location="booking"
      className="section-padding bg-gradient-to-br from-primary/10 via-background to-purple-light/10 scroll-mt-20"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-8 lg:gap-14 items-center">
        <figure className="relative max-w-sm mx-auto md:max-w-none w-full">
          <img
            src={mariaPriestly}
            alt="Maria Priestly, owner of Atlanta Luxury Sprinters and Empress Elite Limousine"
            width={900}
            height={1100}
            loading="lazy"
            decoding="async"
            className="w-full aspect-[4/5] object-cover object-top rounded-lg shadow-2xl"
          />
          <figcaption className="absolute bottom-4 left-4 right-4 rounded-md bg-background/90 backdrop-blur px-4 py-3">
            <p className="font-heading text-lg font-semibold text-foreground leading-tight">Maria Priestly</p>
            <p className="text-muted-foreground text-xs">Owner · {PARENT_BRAND}</p>
          </figcaption>
        </figure>

        <div className="text-center md:text-left">
          <p className="text-primary text-sm tracking-[0.3em] uppercase mb-4 font-medium">Hi, I'm Maria</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-foreground mb-5">{title}</h2>
          <p className="text-muted-foreground text-lg leading-relaxed mb-6">{body}</p>
          <ul className="space-y-2 mb-8 inline-block text-left">
            {PROMISES.map((p) => (
              <li key={p} className="flex items-start gap-2 text-foreground">
                <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" aria-hidden="true" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <ContactButtons className="md:justify-start" />
          <p className="text-muted-foreground text-sm mt-6">
            Atlanta Luxury Sprinters is the luxury Sprinter fleet of {PARENT_BRAND}, my family's company.
          </p>
        </div>
      </div>
    </section>
  );
}
